<template>
  <div class="text-[#FFFFFF99] h-full relative cockpit">
    <div class="h-full overflow-y-scroll">
      <div class="h-7/20">
        <categoryTitle class="my-10px" title="作业基本信息" />
        <div class="h-[calc(100%-38px)] text-14px pb-10px px-5px relative">
          <div
            @click="viewDetail"
            class="view-detail cursor-pointer z-100 absolute w-96px h-32px leading-32px text-center right-10px -top-35px"
          >
            查看详情
          </div>
          <el-row class="h-full">
            <el-col class="my-5px" :span="24">
              <div class="flex">
                <div class="text-right flex-shrink-0 w-100px">工作票内容:</div>
                <div class="text-[#FFFFFFFF] truncate pl-5px" :title="ticketsDetail.prWorkContent">
                  {{ ticketsDetail.prWorkContent }}
                </div>
              </div>
            </el-col>
            <el-col class="my-5px" :span="12">
              <div class="flex">
                <div class="text-right flex-shrink-0 w-100px">编号:</div>
                <div class="text-[#FFFFFFFF] truncate pl-5px" :title="ticketsDetail.prTicketNo">
                  {{ ticketsDetail.prTicketNo }}
                </div>
              </div>
            </el-col>
            <el-col class="my-5px" :span="12">
              <div class="flex">
                <div class="text-right flex-shrink-0 w-50px">状态:</div>
                <div class="text-[#FFFFFFFF] truncate pl-5px">
                  {{ getTicketStateName(ticketsDetail.prTicketState) }}
                </div>
              </div>
            </el-col>
            <el-col class="my-5px" :span="12">
              <div class="flex">
                <div class="text-right flex-shrink-0 w-100px">作业类型:</div>
                <div class="text-[#FFFFFFFF] truncate pl-5px" :title="ticketsDetail.ticketTypeName">
                  {{ ticketsDetail.ticketTypeName }}
                </div>
              </div>
            </el-col>
            <el-col class="my-5px" :span="12">
              <div class="flex">
                <div class="text-right flex-shrink-0 w-50px">专业:</div>
                <div class="text-[#FFFFFFFF] truncate pl-5px" :title="ticketsDetail.ticketTypeName">
                  {{ ticketsDetail.ticketTypeName }}
                </div>
              </div>
            </el-col>
            <el-col class="my-5px" :span="12">
              <div class="flex">
                <div class="text-right flex-shrink-0 w-100px">机组:</div>
                <div class="text-[#FFFFFFFF] truncate pl-5px"></div>
              </div>
            </el-col>
            <el-col class="my-5px" :span="12">
              <div class="flex">
                <div class="text-right flex-shrink-0 w-50px">部门:</div>
                <div
                  class="text-[#FFFFFFFF] truncate pl-5px"
                  :title="ticketsDetail.prDepartmentName"
                >
                  {{ ticketsDetail.prDepartmentName }}
                </div>
              </div>
            </el-col>
            <el-col class="my-5px" :span="12">
              <div class="flex">
                <div class="text-right flex-shrink-0 w-100px">工作负责人:</div>
                <div class="text-[#FFFFFFFF] truncate pl-5px">
                  {{ ticketsDetail.prWorkManagerName }}
                </div>
              </div>
            </el-col>
            <el-col class="my-5px" :span="12">
              <div class="flex">
                <div class="text-right flex-shrink-0 w-50px">班组:</div>
                <div
                  class="text-[#FFFFFFFF] truncate pl-5px"
                  :title="ticketsDetail.prWorkGroupName"
                >
                  {{ ticketsDetail.prWorkGroupName }}
                </div>
              </div>
            </el-col>
            <el-col class="my-5px" :span="24">
              <div class="flex">
                <div class="text-right flex-shrink-0 w-100px">班组成员人数:</div>
                <div class="text-[#FFFFFFFF] truncate pl-5px">
                  {{ ticketsDetail.prWorkMemberNumber }}
                </div>
              </div>
            </el-col>
            <el-col class="my-5px" :span="24">
              <div class="flex">
                <div class="text-right flex-shrink-0 w-102px">是否高风险作业:</div>
                <div
                  class="pl-5px"
                  :class="[
                    ['DONGHUO_LEVEL_ONE', 'DONGHUO_LEVEL_TWO'].includes(ticketsDetail.prTicketType)
                      ? 'text-[#FF0000]'
                      : 'text-[#00FF00]',
                  ]"
                >
                  {{
                    ['DONGHUO_LEVEL_ONE', 'DONGHUO_LEVEL_TWO'].includes(ticketsDetail.prTicketType)
                      ? '是'
                      : '否'
                  }}
                </div>
              </div>
            </el-col>
            <el-col class="my-5px" :span="24">
              <div class="flex">
                <div class="text-right flex-shrink-0 w-102px">联系电话:</div>
                <div class="text-[#FFFFFFFF] truncate pl-5px">{{ ticketsDetail.prPhone }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="h-7/20 mr-10px">
        <categoryTitle class="mb-10px" title="作业远程监控" />
        <div class="h-[calc(100%-28px)]">
          <el-table :data="riskAreaData" height="100%" highlight-current-row>
            <el-table-column
              label="作业风险类型"
              show-overflow-tooltip
              prop="alarmTypeName"
            ></el-table-column>
            <el-table-column
              label="触发时间"
              show-overflow-tooltip
              prop="eventStartTime"
            ></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="h-14/50 mt-10px mr-10px">
        <categoryTitle title="定位监控情况" />
        <div class="h-full">
          <div class="h-1/3 p-condition w-full flex my-10px">
            <div class="flex flex-col justify-center text-center w-1/2">
              <div class="text-20px font-bold opacity-100 text-[#FFFFFFFF]">
                {{ ticketsDetail.prWorkMemberNumber }}
              </div>
              <div>参与改作业人数(人)</div>
            </div>
            <div class="flex flex-col justify-center text-center w-1/2">
              <div class="text-20px font-bold opacity-100 text-[#FFFFFFFF]">
                {{ residualNumber }}
              </div>
              <div>作业区域剩余人数(人)</div>
            </div>
          </div>
          <div class="h-full">
            <v-chart
              :options="lineOption"
              :autoresize="true"
              class="h-full w-full"
              :init-options="{ devicePixelRatio: 2 }"
            ></v-chart>
          </div>
        </div>
        <div class="mt-110px mr-10px relative">
          <categoryTitle title="实时监控画面" />
          <span
            class="block text-12px absolute right-0 top-0 mr-10px cursor-pointer"
            @click="$emit('showVideoWall')"
          >
            电视墙模式
          </span>
          <div class="h-200px">
            <div
              class="w-full h-full relative flex items-center"
              @mouseenter="showIcon = true"
              @mouseleave="showIcon = false"
            >
              <YSPlayer
                :code="currentCamera.code"
                :pIid="currentCamera.pIid"
                class="w-full h-full"
                v-if="showPlayer"
              ></YSPlayer>
              <i
                v-show="showIcon"
                class="el-icon-arrow-left absolute w-25px h-25px rounded-50/100 text-hex-fff cursor-pointer z-10 left-5px inline-block bg-hex-5d7290b3 leading-25px text-center"
                @click="changeCamera('last')"
              ></i>
              <i
                v-show="showIcon"
                class="el-icon-arrow-right absolute w-25px h-25px rounded-50/100 text-hex-fff cursor-pointer z-10 right-5px inline-block bg-hex-5d7290b3 leading-25px text-center"
                @click="changeCamera('next')"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showDilog"
      class="w-1050px h-600px diy-modal absolute -left-1070px px-20px top-0px"
      :loading="fileLoading"
    >
      <cardTitle title="工作票详情" cardType="horizontal" class="w-1050px" />
      <span
        @click="closeDialog"
        class="w-36px block absolute bg-[#3FE8FF4C] h-36px rounded-3.47px text-[#FFFFFFFF] leading-36px text-center text-25px top-15px right-30px"
        >x</span
      >
      <div class="h-[calc(100%-52px)] px-10px">
        <fileView :fileUrl="fileUrl" @fileLoaded="fileLoaded" />
      </div>
    </div>
  </div>
</template>

<script>
import cardTitle from '@/components/cockpit/CardTitle'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { IOTDeviceApi } from '@wiz-api/iot-device-management'
import { WorkTicketApi, OperateTicketApi } from '@wiz-api/huizhou2'
import { StandardAlarmRecordApi } from '@wiz-api/personnel-position'
import { OperationSecurityApi } from '@wiz-api/huizhou2-business'
import { forEach, find, isEmpty, first, findIndex, last, size, cloneDeep, map } from 'lodash'
import dayjs from 'dayjs'
import categoryTitle from '../../../../../components/cockpit/CategoryTitle'

const YSPlayer = () => {
  return import('./video/YSPlayer/newYSPlayer')
}
const fileView = () => {
  return import('./fileView')
}

const standardAlarmRecordApi = new StandardAlarmRecordApi()
const operationSecurityApi = new OperationSecurityApi()
const iotDeviceApi = new IOTDeviceApi()
const dataCategoryApi = new DataCategoryApi()
const operateTicketApi = new OperateTicketApi()
const workTicketApi = new WorkTicketApi()
export default {
  name: 'jobCard',
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  components: { categoryTitle, cardTitle, YSPlayer, fileView },
  data() {
    return {
      waring: false,
      showIcon: false,
      showPlayer: false,
      deviceTypeCode: 'Camera',
      cameraInterval: null,
      residualNumber: 0,
      currentCamera: {},
      cameraList: [],
      fileUrl: '',
      fileLoading: false,
      lineOption: {
        color: ['#ffc058', '#3cd495'],
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          left: 40,
          bottom: 45,
          right: 0,
          top: 40,
        },
        legend: {
          top: 0,
          right: 0,
          data: ['全场总人数', '作业区域剩余人数'],
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: '#fff',
            fontSize: 12,
          },
        },
        xAxis: {
          type: 'category',
          data: [],
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#d9d9d9',
            },
          },
          axisLabel: {
            interval: 'auto',
            formatter: (val) => {
              const timeArr = val.split(' ')
              return `${timeArr[0]}\n${timeArr[1]}`
            },
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#d9d9d9',
            },
            show: false,
          },
          axisTick: {
            show: false,
          },
          nameLocation: 'start',
          splitNumber: 4,
        },
        series: [
          {
            name: '全场总人数',
            data: [],
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
          },
          {
            name: '作业区域剩余人数',
            data: [],
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
          },
        ],
        dataZoom: {
          show: true,
          start: 0,
          end: 80,
          height: 10,
          bottom: '1%',
          textStyle: {
            color: 'rgba(255,255,255,0.6)',
          },
          borderColor: 'transparent',
          backgroundColor: 'rgba(26,64,63,0.4)',
          fillerColor: 'rgba(14,253,198,0.3)',
        },
      },
      ticketStateDic: [
        {
          value: 'WaitCommit',
          name: '待提交',
        },
        {
          value: 'WaitApprove',
          name: '待审批',
        },
        {
          value: 'Executing',
          name: '正在执行',
        },
        {
          value: 'Finished',
          name: '已完成',
        },
        {
          value: 'Cancel',
          name: '已作废',
        },
        {
          value: 'Expired',
          name: '已过期',
        },
        {
          value: 'Archived',
          name: '已归档',
        },
      ],
      code: null,
      showDilog: false,
      pIid: null,
      ticketsDetail: {},
      riskAreaData: [],
    }
  },
  watch: {
    transferProps: {
      handler(val) {
        this.ticketsDetail = cloneDeep(val.data)
        this.getResidualNumber()
        this.getAlarmRecord()
        this.getTicketLineData()
      },
      immediate: true,
    },
  },
  created() {
    // 获取字典-监控画面
    this.getCategoryByCodes()
  },
  beforeDestroy() {
    this.cameraInterval && clearInterval(this.cameraInterval)
  },
  methods: {
    // 获取报警列表
    async getAlarmRecord() {
      const [err, res] = await standardAlarmRecordApi.getList({
        standardFenceId: null,
        alarmType: null,
        startTime: this.ticketsDetail.prLicenseStartTime,
        endTime:
          this.ticketsDetail.prTicketFinishTime || dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        handleState: null,
        alarmRemoveType: 0,
        dataSource: null,
        ids: null,
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err && res.items?.length) {
        forEach(res.items, (item) => {
          item.eventStartTime = dayjs(item.eventStartTime).format('YYYY-MM-DD HH:mm:ss')
        })
        this.riskAreaData = res.items
      }
    },
    async getTicketLineData() {
      const [err, res] = await operationSecurityApi.getPosition({
        ticketId: this.ticketsDetail.prId,
      })
      if (!err && res.data?.factoryPeoples) {
        forEach(res.data.factoryPeoples, (i) => {
          i.time = dayjs(new Date(i.time)).format('YYYY-MM-DD HH:mm:ss')
        })
        this.lineOption.xAxis.data = map(res.data.factoryPeoples, 'time')
        this.lineOption.series[0].data = map(res.data.factoryPeoples, 'count')
        this.lineOption.series[1].data = map(res.data.workAreaRemainderPeoples, 'count')
      }
    },
    // 获取剩余人数
    async getResidualNumber() {
      const [err, res] = await operationSecurityApi.getWorkAreaRemainderPeoples({
        ticketId: this.ticketsDetail.prId,
      })
      if (!err) {
        this.residualNumber = res || 0
      }
    },
    // 获取工作票文件
    async getTicketFile() {
      const [err, res] = await operationSecurityApi.getTicketFileAync({
        businessId: this.ticketsDetail.prId,
      })
      if (!err) {
        const blob = new Blob([res])
        this.fileUrl = window.URL.createObjectURL(blob)
      }
    },
    fileLoaded() {
      this.fileLoading = false
    },
    // 通过工作票状态词获取状态名称
    getTicketStateName(val) {
      const ticketStateName = find(this.ticketStateDic, ['value', val])
      if (ticketStateName) {
        return ticketStateName.name
      }
      return ''
    },
    // 获取数据字典数据-设备类型编码
    async getCategoryByCodes() {
      const [err, data] = await dataCategoryApi.getListByCodes({
        codes: ['IOTDeviceTemplateDeviceType'],
        includeDetails: true,
      })
      if (!err) {
        const IOTCamera = find(data, { code: 'IOTDeviceTemplateDeviceType' })
        if (IOTCamera) {
          const camera = find(IOTCamera.dataItems, { displayName: '摄像头' })
          if (camera) {
            this.deviceTypeCode = camera.code
            await this.getCameraList() // 该方法需求deviceTypeCode字段 由数据字典获取
          }
        }
      }
    },
    // 获取摄像头列表
    async getCameraList() {
      const [err, data] = await iotDeviceApi.getDeviceWithDetailPageList({
        deviceTypeCode: this.deviceTypeCode,
        keyWord: '',
        manufacturerCode: '',
        status: 1, // 仅看在线
        isPosition: '',
        isMonitorRange: '',
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err && data) {
        if (!isEmpty(data.items)) {
          this.currentCamera = first(data.items)
          this.cameraList = data.items
          this.showPlayer = true
          this.cameraInterval = setInterval(() => {
            this.changeCamera('next')
          }, 10000)
        }
      }
    },
    // 切换监控画面
    changeCamera(type) {
      const index = findIndex(this.cameraList, { id: this.currentCamera.id })
      // 'last' 上一个 'next' 下一个
      if (type === 'last') {
        if (index === 0) {
          this.currentCamera = last(this.cameraList)
          return
        }
        this.currentCamera = this.cameraList[index - 1]
      } else {
        if (index === size(this.cameraList) - 1) {
          this.currentCamera = first(this.cameraList)
          return
        }
        this.currentCamera = this.cameraList[index + 1]
      }
    },
    // 打开工作票详情弹窗
    viewDetail() {
      this.getTicketFile()
      this.showDilog = true
      this.fileLoading = true
    },
    // 关闭工作票详情弹窗
    closeDialog() {
      this.showDilog = false
    },
  },
}
</script>
<style lang="scss" scoped>
.view-detail {
  background: url('../../../assets/images/rectangle2.png');
  background-size: 100% 100%;
}
.p-condition {
  background: url('../../../assets/images/p_condition.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.cameraBox {
  height: calc(100% - 50px);
  .toolBox {
    color: #ffffff99;
    font-family: Microsoft YaHei UI;
    font-weight: regular;
    font-size: 20px;
    line-height: normal;
    letter-spacing: 0px;
    text-align: left;
    .direction {
      border-radius: 50%;
      border: 1.93px solid #d9d9d94c;
    }
  }
}
.circuit-mon {
  background: url('../../../assets/images/circuit_mon.png');
  background-size: 100% 100%;
}
.cockpit {
  ::-webkit-scrollbar-thumb {
    background-color: #326970 !important;
  }
  ::-webkit-scrollbar-track-piece {
    background-color: #326970 !important;
  }
}
</style>
